import React from 'react';

export type TableProps = {
    headline: string;
    columnHeaders: string[];
    rowData: string[][];
};

const Table: React.FC<TableProps> = ({ headline, columnHeaders, rowData }) => (
    <div className="pattern">
        <div className="container container--md">
            <h2 className="h3">{headline}</h2>
            <table className="table table--responsive">
                <thead>
                    <tr>
                        {columnHeaders.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rowData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex} data-label={columnHeaders[cellIndex]}>
                                    <span dangerouslySetInnerHTML={{ __html: cell }} />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);

export default Table;